import request from '@/utils/request'

/**
 * 保证金缴纳相关接口，目前接口在业务端，后期将会迁移至支付平台
 * 为方便后期迁移，现将部分接口集中存放
 */

const PURCHASE_API = process.env.VUE_APP_PURCHASE_API
const PAY_API = process.env.VUE_APP_PAY_API

/**
 * 在线申请电子保函
 */
export function applyOnlineLetterApi(orderId, tradeId) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/v2/supplier/bidding-orders/${orderId}/trades/${tradeId}/guarantee-letter/apply`,
    method: 'post'
  })
}

/**
 * 线上电子保函申请撤回
 */
export function cancelApplyOnlineLetterApi(orderId, tradeId) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/v2/supplier/bidding-orders/${orderId}/trades/${tradeId}/guarantee-letter/apply-cancel`,
    method: 'post'
  })
}

/**
 * 线上电子保函申请退回
 */
export function applyForReturnOnlineLetterApi(orderId, tradeId) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/v2/supplier/bidding-orders/${orderId}/trades/${tradeId}/guarantee-letter/refund`,
    method: 'post'
  })
}

/**
 * 撤销线上电子保函退回申请
 */
export function cancelApplyForReturnOnlineLetterApi(orderId, tradeId) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/v2/supplier/bidding-orders/${orderId}/trades/${tradeId}/guarantee-letter/refund-cancel`,
    method: 'post'
  })
}

/**
 * 查询线上保函最新的申请记录
 */
export function getOnlineLetterApplicationNewestApi(businessNo) {
  return request({
    url: PAY_API + `/v1/guarantee/search/detail/${businessNo}`,
    method: 'get'
  })
}

/**
 * 查询线上保函退款记录
 */
export function getOnlineLetterReturnRecordsApi(businessNo) {
  return request({
    url: PAY_API + `/v1/guarantee/search/refund/${businessNo}`,
    method: 'get'
  })
}

/**
 * 线上保函申请开票
 */
export function applyOnlineLetterInvoiceApi(data) {
  return request({
    url: PAY_API + '/v1/guarantee/invoice/applyInvoice',
    method: 'post',
    data
  })
}
